<template>
    
    <div class="st-table-container">

        <div class="st-table-separator"></div>

        <div class="st-table-header"> 

            <img :src="constants.images.seperatorLeft" />

            {{ selectedData.title }}

            <img :src="constants.images.seperatorRight" />
        </div>

        <div class="st-table-main"> 
            <STTableMain />
        </div>
    </div>
</template>

<script>

    import { mapState, mapMutations } from "vuex";

    import STTableMain from "@/components/STTableMain";

    import topTableData from "@/data/topTableData";

    import ImageSeperatorLeft from "@/assets/images/search/seperator-left.png";
    import ImageSeperatorRight from "@/assets/images/search/seperator-right.png";

    export default {
        name: "STTable",
        components: {
            STTableMain
        },
        data() {
            return {
                constants: {
                    images: {
                        seperatorLeft: ImageSeperatorLeft,
                        seperatorRight: ImageSeperatorRight
                    }
                }
            }
        },
        computed: {
            ...mapState(["tOption", "tData"]),
            selectedData() {

                if (!this.tOption) {
                    return {};
                }

                const { type } = this.tOption;

                let updatedType = type;

                switch(type) {
                    case 1:

                        updatedType = 1;

                        break;
                    case 2:

                        updatedType = 2;
                        
                        break;
                    case 3:

                        updatedType = 1;
                        
                        break;
                }
                
                return topTableData[updatedType];
            }
        },
        methods: {
            ...mapMutations(["updateSelectedPlatform"]),
            customizeRow(record) {

                const that = this;
                
                return {
                    on: {
                        click: () => {

                            const { type } = that.tOption;

                            if (type !== 2) {
                                return;
                            }

                            const { platform } = that.tData;

                            const { value } = platform.filter(element => element.name === record.name)[0];

                            that.updateSelectedPlatform({
                                ...record,
                                coord: that.$mapUtils.getPointBMap(value)
                            });
                        }
                    }
                };
            }
        }
    }
</script>

<style lang="scss" scoped>

    .st-table-container {

        color: white;
        margin: 1rem;
        margin-top: -0.5rem;
        margin-left: 0.3rem;
        margin-right: 0.3rem;
        margin-bottom: -1.4rem;
        

        .st-table-separator {
            width: 100%; 
            height: 1px; 
            border: 1px solid #0ECFFF;
            margin-top: 1.5rem;
        }

        .st-table-header {

            display: flex;
            flex-direction: row;
            font-size: 13px;
            justify-content: space-around;
            align-items: center;
            font-weight: bold;
            margin-top: 0.4rem;
            letter-spacing: 0.05rem;

            img {
                width: calc(135px / 2);
                height: calc(21px / 2);
            }
        }

        .st-table-main {
            margin-top: 0.4rem;
        }
    }
</style>